<template>
    <div>
        <slot />
    </div>
</template>

<script>
export default {
    props: [
        'link-class'
    ],
    
    data: () => ({
        showing: false
    }),

    created() {
        // 
    },

    mounted() {},

    computed: {},

    methods: {
        show($event) {
            $event.preventDefault();
            
            this.showing = true;
        },
        
        hide($event) {
            this.showing = false;
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
